<template>
  <div class="NoCollateralProposedOfferCardContainer">
    <ProposedOfferCardContainer
      product-label="Sem garantia"
      v-bind="$attrs"
      :offer="offer"
      :tag="cptdTag"
      :partner="cptdPartnerMap"
      @brand-click="seeConditions"
      @offer-conditions-click="seeConditions"
      @action-forward-click="handleSubmit"
    />
    <OfferDetailsModal
      v-if="displayOfferDetailsModal"
      :offer="offer"
      :busy="busy"
      :is-fullscreen-mobile="true"
      :product-type="cptdProductType"
      :display-faqs="cptdCurrentPartnerFaqs.length > 0"
      :display="displayOfferDetailsModal"
      @close="displayOfferDetailsModal = false"
      @openFaqs="displayFaqsModal = true"
      @submit="handleSubmit"
    />

    <!-- Simplic pre select offer dialog -->
    <SimplicPreSelectOfferModal
      v-if="displaySimplicPreSelectOfferModal"
      :display="displaySimplicPreSelectOfferModal"
      :busy="busy"
      @close="displaySimplicPreSelectOfferModal = false"
      @submit="handleSubmit"
    />

    <OfferPartnerTimeoutFeedbackDialog
      v-if="displayOfferPartnerTimeoutFeedback"
      :display="displayOfferPartnerTimeoutFeedback"
      :partner="offer.partner"
    />

    <!-- faqs modal -->
    <CommomQuestionsComponent
      v-if="displayFaqsModal"
      :subject="cptdPartner"
      :questions="cptdCurrentPartnerFaqs"
      @close="displayFaqsModal = false"
    />

    <!-- modal -->
    <OfferEditModal
      :display="displayEditModal"
      @close="displayEditModal = false"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import {
  partnerHasFullIntegration,
  waitForAResultWithOptions,
} from '@/helpers/offers'
import {
  PartnerEditableConditions,
  PartnersName,
} from '@/helpers/partners/common'

import { GtmPushDataLayer } from '@/helpers/google'
import OfferPartnerTimeoutFeedbackDialog from '@/components/loans/OfferPartnerTimeoutFeedbackDialog.vue'
import OfferDetailsModal from '@/components/commomComponents/modals/OfferDetailsModal.vue'
import ProposedOfferCardContainer from '@/containers/loans/ProposedOfferCardContainer.vue'
import OfferEditModal from '@/components/commomComponents/modals/OfferEditModal.vue'
import CommomQuestionsComponent from '@/components/commomComponents/CommomQuestionsComponent.vue'
import { PartnersFaq } from '~/helpers/partners/partnersFaq'
import { Partner } from '@/data/common'
import SimplicPreSelectOfferModal from '@/containers/loans/no-collateral/offer/partners/SimplicPreSelectOfferModal.vue'

export default {
  name: 'NoCollateralProposedOfferCardContainer',
  components: {
    OfferPartnerTimeoutFeedbackDialog,
    OfferDetailsModal,
    ProposedOfferCardContainer,
    OfferEditModal,
    CommomQuestionsComponent,
    SimplicPreSelectOfferModal,
  },
  props: {
    offer: { type: Object, required: true },
    customPartnerTags: { type: Object, default: undefined },
  },
  data() {
    return {
      displayOfferDetailsModal: false,
      displayOfferPartnerTimeoutFeedback: false,
      busy: false,
      errorMsg: 'Algo deu errado! Por favor tente novamente.',
      displayFaqsModal: false,
      displayEditModal: false,
      displaySimplicPreSelectOfferModal: false,
    }
  },
  computed: {
    ...mapGetters({
      gtUser: 'user/user/gtUser',
      personaData: 'user/persona/personaData',
      gtNoCollateralOfferSelected:
        'products/loans/no-collateral/no-collateral/gtNoCollateralOfferSelected',
      gtNocollateralOffersStatistics:
        'statistics/statistics/gtNocollateralOffersStatistics',
    }),
    cptdProductType() {
      if (this.cptdPartner === Partner.JUVO) {
        return 'Celular em garantia'
      }

      return 'Empréstimo sem garantia'
    },
    cptdIsOfferEditable() {
      return PartnerEditableConditions[this.offer?.partner ?? '']
    },
    cptdCurrentPartnerFaqs() {
      return PartnersFaq[this.cptdPartner] ?? []
    },
    cptdPartner() {
      return this.offer?.partner ?? ''
    },
    cptdPartnerName() {
      return PartnersName[this.cptdPartner ?? ''] ?? ''
    },
    cptdPartnerMap() {
      const partnerRemap = {
        ITAU: 'ITI',
      }

      return partnerRemap[this.cptdPartner ?? ''] || this.cptdPartner
    },
    cptdTag() {
      return this.customPartnerTags?.[this.cptdPartner] ?? null
    },
  },
  mounted() {
    if (this.cptdIsOfferEditable) {
      this.actEmitGaEvent({
        eventLabel: 'fakedoor-noverde-edit-details',
        eventCategory: 'fakedoor-noverde-edit-details',
        eventAction: 'saw-card',
      })
    }
  },
  methods: {
    ...mapActions({
      createFeedback: 'utils/feedback/createFeedback',
      actSelectNoCollateralOffer:
        'products/loans/no-collateral/no-collateral/actSelectNoCollateralOffer',
      actSetNoCollateralOfferSelected:
        'products/loans/no-collateral/no-collateral/actSetNoCollateralOfferSelected',
      actGetNoCollateralOfferById:
        'products/loans/no-collateral/no-collateral/actGetNoCollateralOfferById',
      actEmitGaEvent: 'services/ga/actEmitGaEvent',
      actSetLastLoanInteraction: 'ui/user-activity/actSetLastLoanInteraction',
    }),
    seeConditions() {
      if (this.cptdIsOfferEditable) {
        this.actEmitGaEvent({
          eventLabel: 'fakedoor-noverde-edit-details',
          eventCategory: 'fakedoor-noverde-edit-details',
          eventAction: 'click-view-details-card',
        })
      }
      this.displayOfferDetailsModal = true
      this.displaySimplicPreSelectOfferModal = false
    },
    async selectOffer() {
      const { offer_id, partner } = this.offer

      this.busy = true

      const selectResponse = await this.actSelectNoCollateralOffer({
        offer: this.offer,
      })
      if (selectResponse?.status === 200) {
        let offer = null
        try {
          // GTM EVENT
          GtmPushDataLayer({
            user_id: this.gtUser?.id ?? '',
            nocollateral_accept_amount: this.offer?.amount ?? '',
          })

          offer = await waitForAResultWithOptions(
            {
              partner: partner.toUpperCase(),
              status: 'ONGOING',
              sub_status: 'SELECTED',
            },
            async () => {
              return await this.actGetNoCollateralOfferById(offer_id)
            },
          )
          if (offer) {
            this.actSetLastLoanInteraction('no-collateral')
            this.actSetNoCollateralOfferSelected(offer)
            if (
              partnerHasFullIntegration({
                partner,
                product_type: 'no-collateral',
              })
            ) {
              this.$router.push({
                path: `/contratacao/sem-garantia/${partner.toLowerCase()}/${offer_id}`,
              })
            } else {
              this.$router.push({
                path: `/contratacao/sem-garantia/${partner?.toLowerCase()}/${offer_id}/redirecionamento`,
              })
            }
          } else {
            this.displayOfferPartnerTimeoutFeedback = true
          }
        } catch (e) {
          if (e?.message === 'MAX_RETRIES_REACHED') {
            this.displayOfferPartnerTimeoutFeedback = true
          } else {
            this.createFeedback({ text: this.errorMsg })
          }
        }
      } else {
        if (selectResponse === 'REDIRECTED_TO_PARTNER_PAGES') {
          this.actSetNoCollateralOfferSelected(this.offer)
          return
        }
        this.createFeedback({ text: this.errorMsg })
      }
      this.busy = false
    },
    handleSubmit() {
      if (
        this.cptdPartner === Partner.SIMPLIC &&
        !this.displaySimplicPreSelectOfferModal
      ) {
        this.displayOfferDetailsModal = false
        this.displaySimplicPreSelectOfferModal = true
        return
      }

      this.selectOffer()
    },
  },
}
</script>
<style lang="scss"></style>
